import React from 'react';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="back-to-app" onClick={() => window.location.href = '/'}>
          ← Back to AFTERSET
        </button>
        
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: January 27, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using AFTERSET ("the Service") at afterset.app, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Service.</p>
          <p><strong>Service Operator:</strong> Nicholas Rivera<br/>
          <strong>Contact:</strong> content.nr17@gmail.com<br/>
          <strong>Location:</strong> Illinois, United States</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>AFTERSET is a Progressive Web App (PWA) that helps festival-goers organize, store, and relive their festival memories through photo and video organization, AI-powered festival detection, and immersive viewing experiences.</p>
          
          <h3>2.1 Free Tier</h3>
          <ul>
            <li>Up to 3 festivals</li>
            <li>Up to 500 memories (photos/videos)</li>
            <li>Basic features</li>
          </ul>

          <h3>2.2 AFTERSET+ (Paid Subscription)</h3>
          <ul>
            <li>Unlimited festivals</li>
            <li>Unlimited memories</li>
            <li>All features unlocked</li>
            <li>Pricing: $4.99/month or $49.99/year</li>
          </ul>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          
          <h3>3.1 Account Creation</h3>
          <ul>
            <li>You must provide accurate and complete information</li>
            <li>You must be at least 13 years old to use the Service</li>
            <li>You are responsible for maintaining account security</li>
            <li>You must not share your account credentials</li>
          </ul>

          <h3>3.2 Account Termination</h3>
          <ul>
            <li>You may delete your account at any time</li>
            <li>We may suspend or terminate accounts that violate these Terms</li>
            <li>Upon termination, your data will be deleted within 30 days</li>
          </ul>
        </section>

        <section>
          <h2>4. User Content</h2>
          
          <h3>4.1 Your Content</h3>
          <ul>
            <li>You retain all rights to photos and videos you upload</li>
            <li>You grant AFTERSET a license to store, display, and process your content solely to provide the Service</li>
            <li>You are responsible for the content you upload</li>
            <li>You must own or have permission to upload all content</li>
          </ul>

          <h3>4.2 Prohibited Content</h3>
          <p>You may NOT upload content that:</p>
          <ul>
            <li>Violates laws or regulations</li>
            <li>Infringes on intellectual property rights</li>
            <li>Contains malware or harmful code</li>
            <li>Is pornographic, obscene, or sexually explicit</li>
            <li>Promotes violence, hate speech, or discrimination</li>
            <li>Violates others' privacy rights</li>
          </ul>
        </section>

        <section>
          <h2>5. Payment Terms</h2>
          
          <h3>5.1 Subscriptions</h3>
          <ul>
            <li>AFTERSET+ subscriptions are billed monthly or annually</li>
            <li>Payments are processed securely through Stripe</li>
            <li>Prices are subject to change with 30 days notice</li>
            <li>Subscriptions auto-renew unless cancelled</li>
          </ul>

          <h3>5.2 Refunds</h3>
          <ul>
            <li><strong>Monthly subscriptions:</strong> No refunds for partial months</li>
            <li><strong>Annual subscriptions:</strong> Pro-rated refund available within 30 days of purchase</li>
            <li>To request a refund, contact content.nr17@gmail.com</li>
          </ul>

          <h3>5.3 Cancellation</h3>
          <ul>
            <li>You may cancel your subscription at any time</li>
            <li>Cancellation takes effect at the end of the current billing period</li>
            <li>You retain access until the end of the paid period</li>
          </ul>
        </section>

        <section>
          <h2>6. Acceptable Use</h2>
          <p>You agree NOT to:</p>
          <ul>
            <li>Use the Service for illegal purposes</li>
            <li>Attempt to hack, disrupt, or damage the Service</li>
            <li>Use automated tools to access the Service (bots, scrapers)</li>
            <li>Impersonate others or create fake accounts</li>
            <li>Spam or harass other users</li>
            <li>Reverse engineer or copy the Service's code</li>
            <li>Upload excessively large files to abuse storage limits</li>
          </ul>
        </section>

        <section>
          <h2>7. Intellectual Property</h2>
          
          <h3>7.1 AFTERSET's IP</h3>
          <ul>
            <li>The Service, including code, design, and branding, is owned by Nicholas Rivera (AFTERSET)</li>
            <li>You may not copy, modify, or distribute the Service</li>
            <li>The AFTERSET name and logo are proprietary</li>
          </ul>

          <h3>7.2 Your IP</h3>
          <ul>
            <li>You retain ownership of your uploaded content</li>
            <li>We do not claim ownership of your photos or videos</li>
          </ul>
        </section>

        <section>
          <h2>8. Disclaimers</h2>
          
          <h3>8.1 Service Availability</h3>
          <ul>
            <li>The Service is provided "AS IS" and "AS AVAILABLE"</li>
            <li>We do not guarantee uninterrupted or error-free service</li>
            <li>We may suspend the Service for maintenance</li>
          </ul>

          <h3>8.2 No Warranties</h3>
          <ul>
            <li>We make no warranties about accuracy, reliability, or completeness</li>
            <li>We do not guarantee AI festival detection will be 100% accurate</li>
            <li>We are not responsible for loss of content due to technical issues</li>
          </ul>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law:</p>
          <ul>
            <li>We are not liable for indirect, incidental, or consequential damages</li>
            <li>Our total liability is limited to the amount you paid in the last 12 months</li>
            <li>We are not liable for data loss, loss of profits, or business interruption</li>
          </ul>
        </section>

        <section>
          <h2>10. Changes to Terms</h2>
          <p>We may update these Terms from time to time. We will notify you of material changes by posting updated Terms on this page and updating the "Last Updated" date. Continued use of the Service after changes constitutes acceptance.</p>
        </section>

        <section>
          <h2>11. Dispute Resolution</h2>
          <p>These Terms are governed by the laws of Illinois, United States. Any disputes will be resolved through binding arbitration in Illinois, except for small claims court disputes and intellectual property disputes.</p>
        </section>

        <section>
          <h2>12. Contact Information</h2>
          <p>For questions, concerns, or notices regarding these Terms:</p>
          <p>
            <strong>Email:</strong> content.nr17@gmail.com<br/>
            <strong>Operator:</strong> Nicholas Rivera<br/>
            <strong>Service:</strong> AFTERSET (afterset.app)<br/>
            <strong>Location:</strong> Illinois, United States
          </p>
          <p>We will respond within 7 business days.</p>
        </section>

        <div className="acknowledgment">
          <p>By using AFTERSET, you acknowledge that you have read and understood these Terms of Service.</p>
          <p><strong>Thank you for using AFTERSET! 🌅</strong></p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
